<template>
    <div class="selectable-block" @click="clickFun">
        <div style="width: 100%;overflow: hidden;height: 100%;">
            <input class="input" type="text" :placeholder="placeholder" v-model="value" readonly>
        </div>
        <div class="selectable-block-suffix">
            <local-svg iconClass="inputbox" class="inputbox"></local-svg>
        </div>
    </div>
</template>
 
<script>
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: String,
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isexpand: false,
            showexpand: false,
        }
    },
    methods: {
        clickFun() {
            this.$emit('click')
        },
        inputFun($event) {
            console.log('$event', $event);
            this.$emit('change', $event)
        }
    },
}
</script>
 
<style scoped lang="scss">
.selectable-block {
    width: 100%;
    height: 32px;
    padding: 0 14px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #E2E7EE;
    background: #F1F2F6;
    cursor: not-allowed;
    display: flex;
    box-sizing: border-box;

    &.normal-input {
        background: #FFFFFF;
        border: 1px solid #E2E7EE;
        cursor: pointer;

        .inputbox:hover{
            color: #1D78FE!important;
        }

        .input{
            cursor: pointer;
        }
    }

    .selectable-block-suffix {
        flex: none;
        padding-left: 14px;
        height: 100%;
        display: flex;
        align-items: center;

        .inputbox {
            width: 1.2rem;
            height: 1.1rem;
            color: #3F5A8B;
        }
    }

    .input {
        width: 100%;
        outline: none;
        height: 100%;
        color: #353940;
        font-weight: 400;
        font-size: 14px;
        outline: none;
        border: none;
        background: transparent;
        cursor: not-allowed;
        line-height: 24px;
    }

    .input::placeholder {
        color: #C2C6D1;
    }
}
</style>